/**
 * Service for loading graph widget data using the Advanced-style API pattern
 * This service can be used by both the Advanced dashboard and the main dashboard
 * for consistent data loading patterns.
 */
angular.module('vrm.components')
    .service('GraphWidgetDataService', ['ApiService', '$q', function(ApiService, $q) {

        /**
         * Load graph widget data using the Advanced-style API pattern
         * @param {string} installationId - Installation ID
         * @param {number} startDate - Start date timestamp
         * @param {number} endDate - End date timestamp
         * @param {number} instance - Widget instance
         * @param {Array<string>} attributeCodes - Array of attribute codes to fetch
         * @param {Object} options - Additional options
         * @returns {Promise} Promise that resolves with the graph data
         */
        this.loadGraphData = function(installationId, startDate, endDate, instance, attributeCodes, options = {}) {
            const width = options.width || Math.floor(window.innerWidth < 768 ? 768 / 4 : 768 / 3);
            const useMinMax = options.useMinMax !== false ? 1 : 0;
            const pointsPerPixel = options.pointsPerPixel || 1;

            let url = 'widgets/Graph' +
                "?start=" + startDate +
                "&end=" + endDate +
                "&instance=" + instance +
                "&width=" + width +
                "&useMinMax=" + useMinMax +
                "&pointsPerPixel=" + pointsPerPixel;

            // Add all attribute codes
            if (attributeCodes && attributeCodes.length > 0) {
                attributeCodes.forEach(attr => {
                    url += '&attributeCodes[]=' + attr;
                });
            }

            // Add custom widget ID if provided
            if (options.idCustomWidget) {
                url += '&idCustomWidget=' + options.idCustomWidget;
            }

            return ApiService.installations(installationId, url).then(function (response) {
                return response.data.records;
            });
        };

        /**
         * Load graph widget data for a specific widget type
         * @param {string} installationId - Installation ID
         * @param {number} startDate - Start date timestamp
         * @param {number} endDate - End date timestamp
         * @param {string} widgetType - Widget type (e.g., 'GridMeterCombined')
         * @param {number} instance - Widget instance
         * @param {Object} options - Additional options
         * @returns {Promise} Promise that resolves with the graph data
         */
        this.loadWidgetTypeData = function(installationId, startDate, endDate, widgetType, instance, options = {}) {
            const widgetTypeAttributeMap = {
                'GridMeterCombined': ['g1c', 'g2c', 'g3c', 'g1v', 'g2v', 'g3v', 'g1p', 'g2p', 'g3p'],
                'AcMeterCombined': ['a1c', 'a2c', 'a3c', 'a1v', 'a2v', 'a3v', 'a1p', 'a2p', 'a3p'],
                'PvInverterCombined': ['pI1', 'pI2', 'pI3', 'pV1', 'pV2', 'pV3', 'pP1', 'pP2', 'pP3']
            };

            const attributeCodes = widgetTypeAttributeMap[widgetType];
            if (!attributeCodes) {
                return $q.reject(new Error('Unknown widget type: ' + widgetType));
            }

            return this.loadGraphData(installationId, startDate, endDate, instance, attributeCodes, options);
        };

    }]);
